// Get the navbar
var navbar = document.getElementById("navbar1");

// Get the offset position of the navbar
var sticky1 = navbar.offsetTop;

window.onscroll = function() {
  if (window.pageYOffset >= sticky1) {
    navbar.classList.add("sticky")
  } else {
    navbar.classList.remove("sticky");
  }
};

let pricediv=document.querySelectorAll('.price');
for(let i=0;i<pricediv.length;i++){
  pricediv[i].style.fontSize='19px';
  pricediv[i].style.color='#7c58dc';
}

let idarray=[];
let namesarray=[];
sections=document.querySelectorAll('.section');
for(let i=2;i<sections.length;i++){
  idarray[i-2]=sections[i].getAttribute('id');
}

h2names=document.querySelectorAll('.section h2');

for(let i=1;i<h2names.length;i++){
  namesarray[i-1]=h2names[i].innerText;
  
}
let navdiv_a=document.querySelector('.navbar2');
for(let i=0;i<namesarray.length;i++){
  let xnew=document.createElement('a');
  xnew.innerText=namesarray[i];
  xnew.setAttribute('href','#'+idarray[i]);
  xnew.setAttribute('class','navbar_a');
  navdiv_a.appendChild(xnew);
}


let a_href=document.querySelectorAll('.navbar_a');






for(let i=0;i<a_href.length;i++){
a_href[i].addEventListener('click',()=>{
    for(let i=0;i<a_href.length;i++){
      sections[i].style.paddingTop='24px';
      a_href[i].setAttribute('state','none');
       a_href[i].style.color='black'
      a_href[i].style.backgroundColor='white';
    }
    sections[i+2].style.paddingTop='90px';
    a_href[i].setAttribute('state','active');
    a_href[i].style.color='white'
    a_href[i].style.backgroundColor='#7753DB';
  
    
})  
}
let x=0;

for(let i=2;i<sections.length;i++){
  
  sections[i].addEventListener('mouseenter',()=>{
    for(let i=0;i<a_href.length;i++){
     a_href[i].setAttribute('state','none');
       a_href[i].style.color='black'
      a_href[i].style.backgroundColor='white';
       
   
  }
    
  
    a_href[i-2].setAttribute('state','active');
    a_href[i-2].style.color='white';
    a_href[i-2].style.backgroundColor='#7753DB';
    let y=document.getElementById('navbar1');
    y.scrollTo(x,0);
    x+=70;
})
  sections[i].addEventListener('mouseleave',()=>{
    a_href[i-2].setAttribute('state','none');
    a_href[i-2].style.color='black';
    a_href[i-2].style.backgroundColor='white';
  
  })
}



